import React, { useState } from 'react'
import { ReactComponent as HeartIcon } from '../../../assets/svg/icons/outlined/heart.svg'
import { ReactComponent as HeartIconFilled } from '../../../assets/svg/icons/filled/heart.svg'

const Heart = ({ style }: { style?: any }) => {
  const [heart, setHeart] = useState(false)

  return !heart ? (
    <HeartIcon style={style} onClick={() => setHeart(prev => !prev)} />
  ) : (
    <HeartIconFilled style={style} onClick={() => setHeart(prev => !prev)} />
  )
}

export default Heart
